export interface MenuItem {
  name: string;
  url: string;
}

export const menuItemsPrototype4: MenuItem[] = [
  { name: 'Spin & Go', url: '/poker/play-poker/spin-and-go/' },
  { name: 'Cash Games', url: '/poker/play-poker/cash-games/simple/' },
  { name: 'Tournaments', url: '/poker/play-poker/tournaments/' },
  { name: 'All in Poker', url: '/poker/play-poker/cash-games/all-in/' }
];

export const menuItemsPrototype3: MenuItem[] = [
  { name: 'Cash Games', url: '/poker/play-poker/cash-games/simple/' },
  { name: 'Power Path', url: '/poker/play-poker/power-path/' },
  { name: 'Seasons', url: '/poker/play-poker/stars-season/' },
  { name: 'Spin & Go', url: '/poker/play-poker/spin-and-go/' },
  { name: 'Tournaments', url: '/poker/play-poker/tournaments/' },
  { name: 'Home Games', url: '/homegames/' },
  { name: 'All in Poker', url: '/poker/play-poker/cash-games/all-in/' }
];
